
export default function Attribute(props: { attribute: string }) {
    let [key, value] = props.attribute.split(':');

    return (
        <div style={{ width: '150px', padding: '10px', borderRadius: '8px', backgroundColor: 'darkgrey'}}>
            <div style={{fontSize: '10px', color: '#555555'}}>{key}</div>
            <div style={{fontSize: '12px', color: 'white'}}>{value}</div>
        </div>
    );
}
